import { useQuery } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import { UADMGetNonConformanceContainerMTUResponse } from "../../odata/appu4dm/AppU4DMModel";
import { QUADMGetNonConformanceContainerMTU2 } from "../../odata/appu4dm/QAppU4DM";
import { ncKeys } from "./nc-keys";

export function useNCMTUs(ncId?: string) {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getNCMTUs(ncId!),
    queryFn: ({ meta }) => fetchNCMTUs(ncId!, meta!.token!),
    enabled: ({ meta }) => !!meta?.token && !!ncId,
  });

  return {
    ncMTUs: data?.value,
    ...query,
  };
}

async function fetchNCMTUs(ncId: string, token: string) {
  const path = new QUADMGetNonConformanceContainerMTU2().buildUrl({
    function: {
      Id: ncId,
    },
  });

  return odataFetch<UADMGetNonConformanceContainerMTUResponse>({
    path,
    token,
  });
}
